import { render, staticRenderFns } from "./static.vue?vue&type=template&id=cc35566e&scoped=true&"
import script from "./static.vue?vue&type=script&lang=js&"
export * from "./static.vue?vue&type=script&lang=js&"
import style0 from "./static.vue?vue&type=style&index=0&id=cc35566e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc35566e",
  null
  
)

component.options.__file = "static.vue"
export default component.exports